import Toastr from "./Toastr";

export default Toastr;
